import gql from 'graphql-tag'

export const ADDRESS_CATEGORIES_QUERY = gql`
    query addressCategories {
        addressCategories {
            id
            key
            name
        }
    }
`
